'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var errCode = require('err-code');

var CID = require('cids');
/*
 * Transform one of:
 *
 * ```
 * CID
 * String
 * { cid: CID recursive, metadata }
 * { path: String recursive, metadata }
 * Iterable<CID>
 * Iterable<String>
 * Iterable<{ cid: CID recursive, metadata }>
 * Iterable<{ path: String recursive, metadata }>
 * AsyncIterable<CID>
 * AsyncIterable<String>
 * AsyncIterable<{ cid: CID recursive, metadata }>
 * AsyncIterable<{ path: String recursive, metadata }>
 * ```
 * Into:
 *
 * ```
 * AsyncIterable<{ path: CID|String, recursive, metadata }>
 * ```
 *
 * @param input Object
 * @return AsyncIterable<{ path: CID|String, recursive, metadata }>
 */


module.exports = function normaliseInput(input) {
  // must give us something
  if (input === null || input === undefined) {
    throw errCode(new Error("Unexpected input: ".concat(input), 'ERR_UNEXPECTED_INPUT'));
  } // CID|String


  if (CID.isCID(input) || input instanceof String || typeof input === 'string') {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return toPin({
                cid: input
              });

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  } // { cid: CID recursive, metadata }


  if (input.cid != null || input.path != null) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return toPin(input);

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  } // Iterable<?>


  if (input[Symbol.iterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var iterator, first, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, cid, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, obj;

      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              // eslint-disable-line require-await
              iterator = input[Symbol.iterator]();
              first = iterator.next();

              if (!first.done) {
                _context3.next = 4;
                break;
              }

              return _context3.abrupt("return", iterator);

            case 4:
              if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
                _context3.next = 34;
                break;
              }

              _context3.next = 7;
              return toPin({
                cid: first.value
              });

            case 7:
              _iteratorNormalCompletion3 = true;
              _didIteratorError3 = false;
              _iteratorError3 = undefined;
              _context3.prev = 10;
              _iterator3 = iterator[Symbol.iterator]();

            case 12:
              if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                _context3.next = 19;
                break;
              }

              cid = _step3.value;
              _context3.next = 16;
              return toPin({
                cid: cid
              });

            case 16:
              _iteratorNormalCompletion3 = true;
              _context3.next = 12;
              break;

            case 19:
              _context3.next = 25;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3["catch"](10);
              _didIteratorError3 = true;
              _iteratorError3 = _context3.t0;

            case 25:
              _context3.prev = 25;
              _context3.prev = 26;

              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }

            case 28:
              _context3.prev = 28;

              if (!_didIteratorError3) {
                _context3.next = 31;
                break;
              }

              throw _iteratorError3;

            case 31:
              return _context3.finish(28);

            case 32:
              return _context3.finish(25);

            case 33:
              return _context3.abrupt("return");

            case 34:
              if (!(first.value.cid != null || first.value.path != null)) {
                _context3.next = 64;
                break;
              }

              _context3.next = 37;
              return toPin(first.value);

            case 37:
              _iteratorNormalCompletion4 = true;
              _didIteratorError4 = false;
              _iteratorError4 = undefined;
              _context3.prev = 40;
              _iterator4 = iterator[Symbol.iterator]();

            case 42:
              if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                _context3.next = 49;
                break;
              }

              obj = _step4.value;
              _context3.next = 46;
              return toPin(obj);

            case 46:
              _iteratorNormalCompletion4 = true;
              _context3.next = 42;
              break;

            case 49:
              _context3.next = 55;
              break;

            case 51:
              _context3.prev = 51;
              _context3.t1 = _context3["catch"](40);
              _didIteratorError4 = true;
              _iteratorError4 = _context3.t1;

            case 55:
              _context3.prev = 55;
              _context3.prev = 56;

              if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                _iterator4.return();
              }

            case 58:
              _context3.prev = 58;

              if (!_didIteratorError4) {
                _context3.next = 61;
                break;
              }

              throw _iteratorError4;

            case 61:
              return _context3.finish(58);

            case 62:
              return _context3.finish(55);

            case 63:
              return _context3.abrupt("return");

            case 64:
              throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

            case 65:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[10, 21, 25, 33], [26,, 28, 32], [40, 51, 55, 63], [56,, 58, 62]]);
    }))();
  } // AsyncIterable<?>


  if (input[Symbol.asyncIterator]) {
    return _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var iterator, first, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, cid, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, obj;

      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              iterator = input[Symbol.asyncIterator]();
              _context4.next = 3;
              return _awaitAsyncGenerator(iterator.next());

            case 3:
              first = _context4.sent;

              if (!first.done) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return", iterator);

            case 6:
              if (!(CID.isCID(first.value) || first.value instanceof String || typeof first.value === 'string')) {
                _context4.next = 44;
                break;
              }

              _context4.next = 9;
              return toPin({
                cid: first.value
              });

            case 9:
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context4.prev = 11;
              _iterator = _asyncIterator(iterator);

            case 13:
              _context4.next = 15;
              return _awaitAsyncGenerator(_iterator.next());

            case 15:
              _step = _context4.sent;
              _iteratorNormalCompletion = _step.done;
              _context4.next = 19;
              return _awaitAsyncGenerator(_step.value);

            case 19:
              _value = _context4.sent;

              if (_iteratorNormalCompletion) {
                _context4.next = 27;
                break;
              }

              cid = _value;
              _context4.next = 24;
              return toPin({
                cid: cid
              });

            case 24:
              _iteratorNormalCompletion = true;
              _context4.next = 13;
              break;

            case 27:
              _context4.next = 33;
              break;

            case 29:
              _context4.prev = 29;
              _context4.t0 = _context4["catch"](11);
              _didIteratorError = true;
              _iteratorError = _context4.t0;

            case 33:
              _context4.prev = 33;
              _context4.prev = 34;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context4.next = 38;
                break;
              }

              _context4.next = 38;
              return _awaitAsyncGenerator(_iterator.return());

            case 38:
              _context4.prev = 38;

              if (!_didIteratorError) {
                _context4.next = 41;
                break;
              }

              throw _iteratorError;

            case 41:
              return _context4.finish(38);

            case 42:
              return _context4.finish(33);

            case 43:
              return _context4.abrupt("return");

            case 44:
              if (!(first.value.cid != null || first.value.path != null)) {
                _context4.next = 82;
                break;
              }

              _context4.next = 47;
              return toPin(first.value);

            case 47:
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context4.prev = 49;
              _iterator2 = _asyncIterator(iterator);

            case 51:
              _context4.next = 53;
              return _awaitAsyncGenerator(_iterator2.next());

            case 53:
              _step2 = _context4.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context4.next = 57;
              return _awaitAsyncGenerator(_step2.value);

            case 57:
              _value2 = _context4.sent;

              if (_iteratorNormalCompletion2) {
                _context4.next = 65;
                break;
              }

              obj = _value2;
              _context4.next = 62;
              return toPin(obj);

            case 62:
              _iteratorNormalCompletion2 = true;
              _context4.next = 51;
              break;

            case 65:
              _context4.next = 71;
              break;

            case 67:
              _context4.prev = 67;
              _context4.t1 = _context4["catch"](49);
              _didIteratorError2 = true;
              _iteratorError2 = _context4.t1;

            case 71:
              _context4.prev = 71;
              _context4.prev = 72;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context4.next = 76;
                break;
              }

              _context4.next = 76;
              return _awaitAsyncGenerator(_iterator2.return());

            case 76:
              _context4.prev = 76;

              if (!_didIteratorError2) {
                _context4.next = 79;
                break;
              }

              throw _iteratorError2;

            case 79:
              return _context4.finish(76);

            case 80:
              return _context4.finish(71);

            case 81:
              return _context4.abrupt("return");

            case 82:
              throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');

            case 83:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[11, 29, 33, 43], [34,, 38, 42], [49, 67, 71, 81], [72,, 76, 80]]);
    }))();
  }

  throw errCode(new Error('Unexpected input: ' + typeof input), 'ERR_UNEXPECTED_INPUT');
};

function toPin(input) {
  var pin = {
    path: input.cid || input.path,
    recursive: input.recursive !== false
  };

  if (input.metadata != null) {
    pin.metadata = input.metadata;
  }

  return pin;
}